import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addAttendance } from "../../api/attendanceApi"; // Adjust the path to match your project structure

// Async thunk for adding attendance
export const addAttendanceThunk = createAsyncThunk(
  "attendance/addAttendance",
  async (attendanceData, { rejectWithValue }) => {
    const AttendanceData = attendanceData.attendance;

    try {
      const response = await addAttendance({
        AttendanceData,
      });
      if (!response.data.status) {
        throw response.data.message;
      }
      return response.data; // Assuming API response has a `data` property
    } catch (error) {
      // Return the error in a standard format

      throw error;
    }
  }
);

// Initial state
const initialState = {
  data: null, // Response data
  loading: false,
  error: null,
};

// Attendance slice
const attendanceSlice = createSlice({
  name: "attendance",
  initialState,
  reducers: {
    clearAttendanceState(state) {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addAttendanceThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAttendanceThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addAttendanceThunk.rejected, (state, { error }) => {
        state.loading = false;
        state.error = error.message;
      });
  },
});

// Export actions and reducer
export const { clearAttendanceState } = attendanceSlice.actions;
export default attendanceSlice.reducer;
